var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50318 0.28125V2.74529L0.871094 7.79457V28.7188H27.3994V7.79457L20.7673 2.74529V0.28125H7.50318ZM9.71387 2.86648H18.5567V12.8034L14.1353 16.1562L9.71387 12.8034V2.86648ZM10.8192 5.4517V8.03693H17.4513V5.4517H10.8192ZM7.50318 5.81525V11.1069L4.01443 8.48127L7.50318 5.81525ZM20.7673 5.81525L24.2561 8.48127L20.7673 11.1069V5.81525ZM10.8192 9.32955V11.9148H17.4513V9.32955H10.8192ZM3.08179 10.8645L14.1353 19.2261L25.1887 10.8645V26.1335H3.08179V10.8645Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.eaf104333db6d3d46581a6f9c9dfa848.svg";
export { ForwardRef as ReactComponent };